// material-ui
import { useTheme } from '@mui/material/styles';
import logo from 'assets/images/icons/priseen-enterprise-icon.svg';

// ==============================|| LOGO SVG ||============================== //

const PriseenIcon = ({ width }) => {
  const theme = useTheme();

  return <img src={logo} alt="Priseen" width={width ? width : '150'} />;
};

export default PriseenIcon;
